import { render, staticRenderFns } from "./UsersEditModal.vue?vue&type=template&id=0631c50c&scoped=true"
import script from "./UsersEditModal.vue?vue&type=script&lang=js"
export * from "./UsersEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631c50c",
  null
  
)

export default component.exports